import { h, Component } from 'preact';
import { joinClasses, triggerAnim } from 'utils/utils';
import { hasUnsavedChanges, save } from 'utils/data';
import { listErrors } from 'utils/errors';
import { alert, toast } from 'utils/modal';

// import ErrorTooltip from 'components/tooltip/errorTooltip';
import WithTooltip from 'components/tooltip/withTooltip';
import Button from 'components/button/button';
import AlertCircle from 'components/icons/alertCircle';
// import AlertTriangle from 'components/icons/alertTriangle';

import s from 'components/button/saveButton.sss';

const wait = ms => new Promise(r => setTimeout(r, ms));

export default class SaveButton extends Component {
	constructor(props) {
		super(props);

		this.state = {
			saving: false,
		};

		this.save = this.save.bind(this);
	}

	saveRaw() {
		if (!this.props.dummy) {
			return save(this.props.path);
		}
		return wait(Math.random() * 1000);
	}

	async save() {
		if (this.state.saving) return;
		this.setState({ saving: true });
		try {
			await this.saveRaw();
			this.base.classList.remove(s.saving);
			triggerAnim(this.base, s.saved);
			toast('Site saved!', { icon: 'save' });
			this.setState({ saving: false, saved: true });
		} catch (e) {
			console.error('Save error', e);
			alert('Sorry, an error occurred while saving', { title: 'Error' });
			this.setState({ saving: false, error: true });
		}
	}

	render(props, state) {
		let text = props.children?.length ? props.children : 'Save';
		const { errors, warnings } = listErrors(props.path);

		let tooltip;
		if (errors?.length || warnings?.length) {
			const hasErrors = errors?.length;
			tooltip = {
				icon: hasErrors ? <AlertCircle class={s.error} /> : <AlertCircle />,
				content: [
					...errors.map((error, index) => <div key={`error-${index}`}>Error: {error}</div>),
					...warnings.map((warning, index) => <div key={`warning-${index}`}>Warning: {warning}</div>),
				],
			};
		}
		return (
			<Button
				class={joinClasses(props.class, s.button, state.saving && s.saving, state.saved && s.saved, props.dark && s.dark)}
				dark={props.dark}
				icon="save"
				iconAlt="check"
				disabled={(errors.length > 0 || !props.path || !hasUnsavedChanges(props.path)) && !props.dummy}
				onClick={this.save}
			>
				{text}
				{!!tooltip && (
					<WithTooltip class={s.help} dark={props.dark} direction="bottom" align="center" tooltip={tooltip.content}>
						{tooltip.icon}
					</WithTooltip>
				)}
			</Button>
		);
	}
}